import { defineMessages } from '@jutro/locale';

export default defineMessages({
    effectiveDate :{
        id: 'ml.gateway.views.historyandNotes.Effective Date',
        defaultMessage: 'EFFECTIVE DATE'
    },
    policyX :{
        id: 'ml.gateway.views.historyandNotes.Policy #',
        defaultMessage: 'POLICY #'
    },
    category :{
        id: 'ml.gateway.views.historyandNotes.Category',
        defaultMessage: 'CATEGORY'
    },
    description :{
        id: 'ml.gateway.views.historyandNotes.Description',
        defaultMessage: 'DESCRIPTION'
    },
    showHistory :{
        id: 'ml.gateway.views.historyandNotes.show history',
        defaultMessage: 'Show history'
    },
    hideHistory :{
        id: 'ml.gateway.views.historyandNotes.hide history',
        defaultMessage: 'Hide history'
    },
    addNote :{
        id: 'ml.gateway.views.historyandNotes.Add a Note',
        defaultMessage: 'ADD A NOTE'
    },
    noNotes :{
        id: 'ml.gateway.views.historyandNotes.No notes available for this',
        defaultMessage: 'No notes available for this'
    },

});
